<input type="date" class="form-control" [ngModel]="date | date: 'yyyy-MM-dd'" (ngModelChange)="DateChange($event)" />
